import * as TaskRunner from 'util/TaskRunner';

export interface ExportDataFrameAsCSVResponse {
  fileName: string;
  url: string;
}

export function exportDataFrameAsCSV(dataFrameId: string): Promise<ExportDataFrameAsCSVResponse> {
  return TaskRunner.postJSONPromise({
    url: `/1/api/data-frames/${dataFrameId}/export-csv`,
  });
}
